<template>
  <div id="ticketCode-layout">
    <div class="inputBox">
      <p>输入八位验证码：</p>
      <el-input v-model="ticketCode" @keyup.enter.native="cheackCode"></el-input>
      <p>入场人数：</p>
      <el-input v-model="nowPerson" @keyup.enter.native="personIn"></el-input>
    </div>
    <div class="showBox">
      <h2>购票信息：</h2>
      <div class="box">
        <p class="title">购票人姓名：</p>
        <p class="input">{{ticketInfo.person}}</p>
      </div>
      <div class="box">
        <p class="title">购票人手机号：</p>
        <p class="input">{{ticketInfo.phoneNum}}</p>
      </div>
      <div class="box">
        <p class="title">购票数量(剩余票数)：
          <!-- <span class="other-info">若该项为0则不可入场</span> -->
          </p>
        <p class="input">{{ticketInfo.ticketNum < 1 ? '已无入场次数':ticketInfo.ticketNum}}</p>
      </div>
      <div class="box">
        <p class="title">购票类型：</p>
        <p class="input">{{ticketInfo.ticketType}}</p>
      </div>
      <div class="box">
        <p class="title">购票人邮箱：</p>
        <p class="input">{{ticketInfo.email}}</p>
      </div>
      <div class="box">
        <p class="title">购票人名片：</p>
        <img :src="ticketInfo.card" alt="" class="input-img" @click="showModel =!showModel">
      </div>
    </div>
    <div id="modle" v-if="showModel" @click="showModel = !showModel">
      <img :src="ticketInfo.card" alt="">
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      ticketCode: "",
      showModel: false,
      ticketInfo: {},
      nowPerson: 0,
      alowd: false
    };
  },
  computed: {},
  methods: {
    cheackCode() {
      axios({
        method: "post",
        url: `/acapi/ac/estateforum_ticket/tickCode`,
        data: {
          ticketCode: this.ticketCode
        }
      }).then(res => {
        if (res.data.statusCode === 200) {
          this.ticketInfo = res.data.result[0];
          this.alowd = this.ticketInfo.ticketNum > 0 ? true : false;
        } else {
          this.$message.error("验证码错误！请输入正确的八位验证码！");
        }
      });
    },
    personIn() {
      this.ticketInfo.ticketNum -= this.nowPerson;
      let ticketInfo = this.ticketInfo;
      let personIn = this.nowPerson;
      axios({
        method: "put",
        url: `/acapi/ac/estateforum_ticket/update`,
        data: { ticketInfo }
      }).then(res => {
        if (res.data.statusCode === 200) {
          this.ticketCode = "";
          this.ticketInfo = {};
          this.nowPerson = 0;
          this.$message({
            type: "seccess",
            message: `登记成功，进入${personIn}人。`
          });
        } else {
          this.$message.error("请检查网络！");
        }
      });
    }
  },
  created() {}
};
</script>


<style scoped>
#ticketCode-layout {
  /* width: 640px; */
  /* margin: 0 auto; */
  margin-left: 50px;
  display: flex;
  /* flex-direction: column; */
  /* height: 100vh; */
  padding: 20px 0;
}
.showBox {
  margin: 30px 0;
}
.box {
  margin: 10px 0;
  display: flex;
}
.title {
  font-weight: 600;
  width: 200px;
}
.input {
  margin-top: 5px;
}
.input-img {
  /* max-width: 500px; */
  max-height: 400px;
}
.other-info {
  font-weight: 200;
  font-size: 12px;
}
.inputBox {
  margin-top: 40px;
  margin-right: 20px;
}
#modle {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(204, 204, 204, 0.385);
  display: flex;
  justify-content: center;
  align-items: center;
}
#modle > img {
  min-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/estateforum/estateforum-cheack-ticket.vue